export const isRelativeFilePath = (str) => {
  return /^\/(.*)/.test(str)
}
